<script>
  import Box from "./Box.svelte";

  export let data;
  export let department;
  export let active;
  export let matchingOutcomes;
  export let searchIsEntered;
  export let step;
  export let isHidden;
  export let isScrollytelling;
  export let index;

  function handleKeydown(event) {
    if (!active || data.indexOf(active) == -1 || !data) return;
    if (event.key == "Escape") {
      active = null;
    }
    if (event.key == "ArrowLeft") {
      if (data.indexOf(active) == 0) return;
      active = data[data.indexOf(active) - 1];
    }
    if (event.key == "ArrowRight") {
      if (data.indexOf(active) == data.length - 1) return;
      active = data[data.indexOf(active) + 1];
    }
  }

  import { topFourDepartments } from "@stores/userData.js";
  import touchscreen from "@stores/touchscreen.js";
</script>

<svelte:window on:keydown={handleKeydown} />
<div
  class="row"
  style="transition: opacity 200ms ease {index * 30}ms;"
  class:unselected={step > 2 &&
    !$topFourDepartments.map((d) => d.Department).includes(department)}
  class:isHidden
>
  <h1>
    {department}
  </h1>
  <div
    class="boxes"
    on:mouseleave={() => {
      if ($touchscreen) return;
      active = null;
    }}
  >
    {#each data as d, i}
      <Box
        isHidden={(isScrollytelling && typeof step !== "number") ||
          (step < 1 && i != 0)}
        data={d}
        index={i}
        {matchingOutcomes}
        {searchIsEntered}
        {isScrollytelling}
        bind:active
      />
    {/each}
  </div>
</div>

<style>
  h1 {
    font-size: 1rem;
    margin-top: 1.25rem;
    font-family: var(--font-serif);
    text-align: right;
  }

  .row {
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
    border-right: 1px solid var(--accent-color);
    border-bottom: 1px solid var(--accent-color);
    padding: 0.5rem;
    transition: opacity 200ms ease;
  }

  .isHidden {
    opacity: 0;
    pointer-events: none;
  }

  .unselected {
    opacity: 0.35;
  }

  .boxes {
    display: flex;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 568px) {
    h1 {
      font-size: 0.85rem;
      margin-top: 0.7rem;
    }
  }
</style>
